<script setup lang="ts">
import { cn } from '@laam/lib/utils';
import {
	PinInputRoot,
	type PinInputRootEmits,
	type PinInputRootProps,
	useForwardPropsEmits,
} from 'radix-vue';
import { type HTMLAttributes, computed } from 'vue';

const props = withDefaults(
	defineProps<PinInputRootProps & { class?: HTMLAttributes['class'] }>(),
	{
		class: '',
		modelValue: () => [],
	},
);
const emits = defineEmits<PinInputRootEmits>();

const delegatedProps = computed(() => {
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const { class: _, ...delegated } = props;
	return delegated;
});

const forwarded = useForwardPropsEmits(delegatedProps, emits);
</script>

<template>
	<PinInputRoot
		v-bind="forwarded"
		:class="cn('flex items-center justify-between', props.class)"
	>
		<slot />
	</PinInputRoot>
</template>
